const Sentry = require('@sentry/node')
const Cookie = require('js-cookie')
const getConfig = require('next/config').default
const { USER_ID_COOKIE_NAME } = getConfig().publicRuntimeConfig

function captureException(err, context = 'global', options = {}) {
  const { req, res, extra } = options
  Sentry.configureScope(scope => {
    if (err.message) {
      // De-duplication currently doesn't work correctly for SSR / browser errors
      // so we force deduplication by error message if it is present
      scope.setFingerprint([err.message])
    }

    if (err.statusCode) {
      scope.setExtra('statusCode', err.statusCode)
    }

    if (res && res.statusCode) {
      scope.setExtra('statusCode', res.statusCode)
    }

    if (process.browser) {
      scope.setTag('ssr', false)

      const userId = Cookie.get(USER_ID_COOKIE_NAME)

      if (userId) {
        scope.setUser({ id: userId })
      }
    } else {
      scope.setTag('ssr', true)

      if (req) {
        scope.setExtra('url', req.url)
        scope.setExtra('params', req.params)
        scope.setExtra('query', req.query)
        scope.setExtra('headers', req.headers)

        if (req.cookies.userId) {
          scope.setUser({ id: req.cookies.userId })
        }
      }
    }

    if (extra) {
      Object.keys(extra).forEach(key => {
        scope.setExtra(key, extra[key])
      })
    }

    scope.setTag('context', context)
  })

  Sentry.captureException(err)
}

module.exports = {
  captureException,
}
